import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import {
  TXTWCL_To_find_out_moreX_visit_our_Xa_ELL,
  TXTWCL_You_can_set_personal_limits_or_ELL
} from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <>
    <Translation {...TXTWCL_You_can_set_personal_limits_or_ELL} />{' '}
    <Translation
      values={{
        a: (msg: React.ReactNode) => (
          <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
        )
      }}
      {...TXTWCL_To_find_out_moreX_visit_our_Xa_ELL}
    />
  </>
);

export default HelpSectionContent;
